import { render, staticRenderFns } from "./TftHome.vue?vue&type=template&id=2a50dd0a&"
import script from "./TftHome.vue?vue&type=script&lang=js&"
export * from "./TftHome.vue?vue&type=script&lang=js&"
import style0 from "./TftHome.vue?vue&type=style&index=0&id=2a50dd0a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports